<template>
  <div>
    <div :style="{ margin: '-8px' }">
      <v-layout align-center>
        <v-flex class="pa-2">
          <div class="title primary--text">{{ title }}</div>
          <div v-if="subheader" class="subheading mt-1">{{ subheader }}</div>
        </v-flex>
        <v-flex v-if="!isEditing" shrink class="pa-2">
          <v-btn
            icon
            outline
            color="primary"
            :loading="loading"
            class="ma-0"
            @click="isEditing = true"
          >
            <v-icon small>edit</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <div class="pa-2">
        <slot v-if="isEditing" name="edit" :done="done" />
        <slot v-else />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subheader: {
      type: String,
      default: undefined
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEditing: false
    }
  },
  methods: {
    done() {
      this.isEditing = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/SettingPanel.vue